module.exports = __webpack_public_path__ + "img/traffic-thumb-2.25cc1edd.png";